import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-4">
            不满足于吃瓜？
            <br />
            来当爆料人！
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8 leading-relaxed">
            你的爆料可能改变整个圈子。我们严格保护线人身份，优质线索更有丰厚奖励。
          </p>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 bg-primary-500 text-foreground-950 px-8 py-3.5 rounded-full text-sm font-label font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors duration-200"
          >
            立即爆料 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="relative w-full overflow-hidden rounded-lg bg-background-50/50 py-10">
          <div className="flex items-center gap-6 opacity-30">
            {['微博热搜', '抖音热点', '快手热门', '小红书话题', 'B站热门', '知乎热榜', '百度风云榜', '头条热搜'].map((name) => (
              <span key={name} className="text-foreground-500 text-sm font-label font-medium whitespace-nowrap flex-shrink-0">
                {name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}